module.exports = __webpack_public_path__ + "a07a33be804063c32159c9861d8cdb02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-32.png
// module id = 2230
// module chunks = 0